<template>
  <ty-modal :visible="true" :before-close="handleClose" width="90%" height="90%" :fullscreen="isCollapse"
    :transparent="true">
    <div class="ty-flex ty-flex-wrap align-items-stretch ty-gap-15">
      <!-- <div xs="24" sm="24" md="24" lg="16" xl="16"> -->
        <ty-card v-if="invoice" class="invoice-editor w-100">
          <sold-editor v-if="invoice_type==='sold'" :instance="instance_id" :invoice="invoice" class="w-100"/>
          <bought-editor v-else-if="invoice_type==='bought'" :instance="instance_id" :invoice="invoice" />
          <income-editor v-else-if="invoice_type==='income'" :instance="instance_id" :invoice="invoice" />
          <cost-editor v-else-if="invoice_type==='cost'" :instance="instance_id" :invoice="invoice" />
        </ty-card>
      <!-- </div> -->
      <div class="invoice-viewer w-100">
          <invoice-viewer v-if="invoice" :invoice="invoice"/>
      </div>
    </div>
  </ty-modal>
</template>

<script>
  import {
    Instance
  } from '@/classes/TayehApi';

  import {
    IsCollapseMixin
  } from '@/mixins/UI';
  // import Project from '../../components/Project'
  // import axios from 'axios';
  export default {
    data() {
      const {
        getInstance
      } = this;
      return {
        instance_id: getInstance().id,
        loading: false,
        page: 1,
        invoice: null
      }
    },
    inject: ['getInstance'],
    mixins: [
      IsCollapseMixin
    ],
    components: {
      'sold-editor': () => import('../components/ShopSoldInvoiceEditor.vue'),
      'bought-editor': () => import('../components/ShopBoughtInvoiceEditor.vue'),
      'income-editor': () => import('../components/ShopIncomeInvoiceEditor.vue'),
      'cost-editor': () => import('../components/ShopCostInvoiceEditor.vue'),
      'invoice-viewer': () => import('../components/InvoiceViewer/InvoiceViewer.vue'),
    },
    computed: {
      invoice_type() {
        return this.$route.params.invoice_type;
      }
    },
    methods: {
      handleClose() {
        this.$router.back();
      },
      async getInvoice() {
        const res = await Instance.getDraftInvoice(this.instance_id, this.$route.params.invoice_type)
        this.invoice = res.data;
      }
    },
    mounted() {
      this.getInvoice()
    }
  }
</script>
<style scoped>
.invoice-editor {
  min-width: 400px;
  flex: 1.75;
}
.invoice-viewer {
  max-width: 587px;
  flex: 1.25;
}
</style>